import React from 'react';

import {
  Modal,
  Button,
  FormControl,
  FormGroup,
  Col,
  Row
} from 'react-bootstrap';

// import DeleteBtnWithConfirm from '../../../commonComponents/DeleteBtnWithConfirm';
import RequiredMark from '../../../commonComponents/RequiredMark';
import DropDownMenu from '../../../commonComponents/DropDownMenu';
import custJqAjax from '../../../commonJS/custJqAjax';
import autoFill from '../../../commonJS/autoFill';


export default class CategoryModalCt extends React.Component {
  constructor(props) {
    super(props);
    this.handlers = {
      textAreaOnChange: e => {
        const jsInp = e.currentTarget,
          id = jsInp.id,
          value = jsInp.value;

        this.setState({
          [id]: value
        });
      },
      onInputFocus: e => {
        autoFill(e, this);
      },
      onChange: (selection, id, cb) => {
        const value = selection.value;

        this.setState({
          [id]: value
        });

      },
      saveCategory: isUpdate => {
        let formData = new FormData(),
          id = isUpdate ? this.props.tarCateObj.id : '',
          category_name_list = `${this.state.categoryName_tw}|${this.state.categoryName_tw}|${this.state.categoryName_tw}|${this.state.categoryName_tw}`;
        // category_name_list = `${this.state.categoryName_tw}|${this.state.categoryName_en}|${this.state.categoryName_cn}|${this.state.categoryName_ja}`;

        formData.append('path_id_list', this.props.pathIdList);
        formData.append('category_name_list', category_name_list);
        formData.append('sort_pos', this.state.sort);

        if (isUpdate) {
          formData.append('category_id', id);
        }

        custJqAjax({
          type: 'POST',
          url: `/api/W_SaleSky_ProductCategories_Relation_${isUpdate ? 'Update' : 'Post'}.php`,
          data: formData,
          processData: false,
          contentType: false,
          success: res => {
            let nameObj = {
              name_tw: this.state.categoryName_tw,
              name_en: this.state.categoryName_en,
              name_cn: this.state.categoryName_cn,
              name_ja: this.state.categoryName_ja
            };
            // 傳入語言依語系設定
            this.props.onTreeViewModified(isUpdate ? 'update' : 'create', res.result.category_id, nameObj, this.state.sort);
            this.props.closeModal();
          }
        });
      },
      getValidationState: value => (value === 'default' || !value) ? 'error' : null,
      optsSortGen: len => {
        len++;
        let arr = [];
        for (let i = 1; i < len; i++) {
          arr.push({ value: i, label: i });
        }

        return arr;
      }
    }

    this.ajaxsWip = [];

    this.state = {
      // product
      categoryName_tw: '',
      categoryName_en: '',
      categoryName_cn: '',
      categoryName_ja: '',
      optsSort: [],
      sort: 0,
      // common
      btnSaveDisable: true,
      btnDeleteDisable: true,
      onEdit: this.props.categoryActionMode === 'edit' ? true : false,
      onCopy: false,
      editMode: 'View',
      editPermission: true
    }
  }


  componentDidMount() {
    // 產生排序選項
    const mode = this.props.categoryActionMode;
    let sort, optsSort, tempObj = {}, tarCateObj = this.props.tarCateObj;

    switch (mode) {
      case 'create':
        sort = this.props.tarCateParentObjChildNum + 1;
        optsSort = this.handlers.optsSortGen(sort);
        break;
      case 'edit':
      case 'copy':
        if (mode === 'edit') {
          sort = tarCateObj.sort;
          optsSort = this.handlers.optsSortGen(this.props.tarCateParentObjChildNum);
        } else {
          sort = this.props.tarCateParentObjChildNum + 1;
          optsSort = this.handlers.optsSortGen(sort);
        }

        tempObj.categoryName_tw = tarCateObj.name_tw;
        tempObj.categoryName_en = tarCateObj.name_en;
        tempObj.categoryName_cn = tarCateObj.name_cn;
        tempObj.categoryName_ja = tarCateObj.name_ja;
        break;
      default:
    }

    if (this.props.categoryActionMode === 'edit') tempObj.editMode = 'Edit';
    else if (this.props.categoryActionMode === 'copy') tempObj.editMode = 'Copy';
    this.setState({ sort, optsSort, ...tempObj });

    // let productId = '';
    // if(this.props.params && this.props.params.productId) {
    //   productId = this.props.params.productId;
    //   this.handlers.loadProductData(productId);
    // } else document.getElementById('categoryName_tw').focus();

  }

  componentDidUpdate() {
    // 資料驗證ok才可送出
    if (this.state.categoryName_tw === '') {
      if (!this.state.btnSaveDisable) this.setState({ btnSaveDisable: true });
    } else if (this.state.btnSaveDisable) {
      this.setState({ btnSaveDisable: false })
    };
  }

  componentWillUnmount() {
    // this.props.propsPackageFromSkyFamily.ajaxAborter(this.ajaxsWip);
  }

  render() {
    let saveBtn = '',
      // deleteBtn = '',
      editable = 1,
      // modeBtns = '',
      // productId = '',
      saveBtnText = '儲存';

    // if(this.props.params) productId = this.props.params.productId;
    // else  productId = this.props.productId;

    saveBtn = (
      <Button disabled={this.state.btnSaveDisable}
        onClick={() => { this.handlers.saveCategory(this.state.onEdit ? 1 : 0) }}
        style={{ float: 'right', marginLeft: 5, position: 'relative', zIndex: '3' }}>
        {saveBtnText}
      </Button>
    );

    // deleteBtn = this.state.onEdit ? 
    //               <DeleteBtnWithConfirm
    //                 style={{float: 'right', marginLeft: 5, position: 'relative', zIndex: '3'}}
    //                 onClick={this.handlers.deleteProduct}
    //                 title='Are you sure?' />
    //             : '';

    return (
      <Modal id='modal-product-category' keyboard={false} backdrop='static' show={true} onHide={this.props.closeModal} bsSize='large'>
        <Modal.Header>
          <Modal.Title>
            <span style={{ padding: '6px 0px', height: 34, lineHeight: '34px' }}>
              {
                this.props.categoryActionMode !== 'create' ?
                  <span style={{ float: 'left' }}>
                    <span style={{ color: 'rgba(0, 0, 200, .7' }}>{this.state.editMode}</span> Mode
                </span> :
                  <span>
                    New Category
                </span>
              }
            </span>
            <Button onClick={this.props.closeModal} style={{ float: 'right', marginLeft: 5, position: 'relative', zIndex: '3' }}>取消</Button>
            {saveBtn}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <Row>
            <Col sm={12}>
              <div style={{ fontWeight: 'bold', marginBottom: 5 }}><RequiredMark />分類名稱</div>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <FormGroup controlId='categoryName_tw'
                validationState={this.state.categoryName_tw ? null : 'error'}>

                <FormControl
                  autoFocus={true}
                  disabled={!editable}
                  type='text'
                  onFocus={this.handlers.onInputFocus}
                  onChange={this.handlers.textAreaOnChange}
                  value={this.state.categoryName_tw}
                  style={{ height: 36 }} />
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <DropDownMenu
              sm={12}
              disabled={!editable}
              required={false}
              label='排序位置'
              value={this.state.sort}
              stateName='sort'
              onChange={this.handlers.onChange}
              options={this.state.optsSort} />
          </Row>

        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.props.closeModal} style={{ float: 'right', marginLeft: 5, position: 'relative', zIndex: '3' }}>取消</Button>
          {saveBtn}
        </Modal.Footer>
      </Modal>
    );
  }
}


// WEBPACK FOOTER //
// ./src/salesky/routes/product/CategoryModalCt.jsx